import api from '../api'

export async function load() {
  if (this.getState().gettingPreferredBServer) return

  this.setState({
    gettingPreferredBServer: true,
    gettingPreferredBServerError: undefined,
  })

  try {
    const serverInfo = await api.getPreferredBServer()
    this.setState({
      preferredBServerInfo: serverInfo,
      preferredBServer: serverInfo.preferredServer,
      affectedOrganizations: serverInfo.organizations,
    })
  } catch (gettingPreferredBServerError) {
    this.setState({ gettingPreferredBServerError })
  } finally {
    this.setState({ gettingPreferredBServer: undefined })
  }
}

export async function update({ preferredServer }) {
  if (this.getState().updatingPreferredBServer) return

  this.setState({
    updatingPreferredBServer: true,
    updatingPreferredBServerError: undefined,
    preferredBServerUpdateSuccess: undefined,
  })

  try {
    const result = await api.updatePreferredBServer({ preferredServer })
    this.setState({
      preferredBServerInfo: {
        ...this.getState().preferredBServerInfo,
        preferredServer: result.preferredServer,
        isUsingCustomServer: result.preferredServer !== null,
        message: result.message,
      },
      preferredBServer: result.preferredServer,
      affectedOrganizations: result.affectedOrganizations,
      preferredBServerUpdateSuccess: result.message,
    })
  } catch (updatingPreferredBServerError) {
    this.setState({ updatingPreferredBServerError })
  } finally {
    this.setState({ updatingPreferredBServer: undefined })
  }
}

export async function clear() {
  return update.call(this, { preferredServer: null })
}
